import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from './app-config.service';
import {ServiceNames} from '../interfaces/env-config';
import {IAvailabilityUpdateFormData} from '../interfaces/availability-update';
import {Observable, of} from "rxjs";

@Injectable()
export class AvailabilityService {

  readonly CV_API_PREFIX: string;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
  ) {
    this.CV_API_PREFIX = appConfig.serviceUrl(ServiceNames.Cv, 'v1') + '/cv';
  }

  updateAvailability(data: IAvailabilityUpdateFormData): Observable<any> {
    console.log('[AvailabilityService] updateAvailability', data);
    // this.http.put<void>(`${this.CV_API_PREFIX}/availability`, data);
    return of(true); // TODO change when backend will be ready
  }
}
